import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Address } from 'src/app/domain/Address';
import { AddressService, UpdatedAutoCompleteAddressResponse } from 'src/app/services/address.service';
import { CountryService } from 'src/app/services/country.service';
import * as Leaflet from 'leaflet';
import { requiredTrimmed } from '../../stepper/address/address.component';

@Component({
  selector: 'app-address-dialog',
  templateUrl: './address-dialog.component.html',
  styleUrls: ['./address-dialog.component.scss'],
  providers: [DialogService],
})
export class AddressDialogComponent implements OnInit {
  newAddressForm = new FormGroup({
    id: new FormControl(),
    street: new FormControl(null,[requiredTrimmed,Validators.required]),
    zipCode: new FormControl(null,[requiredTrimmed,Validators.required]),
    city: new FormControl(null,[requiredTrimmed,Validators.required]),
    countryCode: new FormControl(null,[requiredTrimmed,Validators.required]),
    longitude: new FormControl(),
    latitude: new FormControl(),
    validatedBy: new FormControl(),
    street2: new FormControl()
  });
  countries: any[];
  selectedCountry: any;
  foundAddresses: any;

  constructor(private countryService: CountryService, private addressService: AddressService, public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit(): void {    
    if (!this.config.data) {
      this.ref.close();
    }    
    this.MapAddreseFormForModal();
    this.fetchCountries();
    if (this.newAddressForm.value.countryCode) {
      this.selectedCountry = this.countries.find((country) => country.code === this.newAddressForm.value.countryCode).code;
    }
  }

  fetchCountries() {
    this.countries = this.countryService.getClientCountries();
  }

  onClearAddress() {
    this.newAddressForm.reset();
  }
  MapAddreseFormForModal() {
    let temp = (this.config.data as FormGroup);    
    this.newAddressForm.controls.city.setValue(temp.get('city')?.value ?? "");
    this.newAddressForm.controls.countryCode.setValue(temp.get('countryCode')?.value ?? "");
    this.newAddressForm.controls.latitude.setValue(temp.get('latitude')?.value ?? 0.0);
    this.newAddressForm.controls.longitude.setValue(temp.get('longitude')?.value ?? 0.0);
    this.newAddressForm.controls.street.setValue(temp.get('street')?.value ?? "");
    this.newAddressForm.controls.street2.setValue(temp.get('street2')?.value ?? "");
    this.newAddressForm.controls.validatedBy.setValue(temp.get('validatedBy')?.value ?? "");
    this.newAddressForm.controls.zipCode.setValue(temp.get('zipCode')?.value ?? "");
    this.newAddressForm.controls.id.setValue(temp.get('id')?.value ?? "");
  }
  setAddress(event: any) {

    this.newAddressForm.patchValue({
      street: event.street,
      zipCode: event.zipCode,
      city: event.city,
      countryCode: event.countryCode,
      longitude: event.longitude,
      latitude: event.latitude,
      validatedBy: event.validatedBy,
      // id: event.id ?? ""
    });
  }

  formattedStreetName(item: Address) {
    if (item && item.street) {
      return `${item.street}`;
    }
    if (item) {
      return `${item}`;
    }
    return '';
  }

  searchAddress(event: any) {
    this.addressService.autoCompleteAddress(event.query).subscribe((addressResult: UpdatedAutoCompleteAddressResponse) => {
      if (addressResult && addressResult.items) {
        this.foundAddresses = addressResult.items;
      }
    });
  }

  addAddress() {
    let temp = {
      city: this.newAddressForm.controls.city.value,
      countryCode: this.newAddressForm.controls.countryCode.value,
      latitude: this.newAddressForm.controls.latitude.value,
      longitude: this.newAddressForm.controls.longitude.value,
      street: this.newAddressForm.controls.street.value,
      Street2: this.newAddressForm.controls.street2.value,
      validatedBy: this.newAddressForm.controls.validatedBy.value,
      zipCode: this.newAddressForm.controls.zipCode.value,
      id: this.newAddressForm.controls.id.value,
    } as Address
    this.ref.close(temp);
  }

  close() {
    // let temp = {
    //   city: this.newAddressForm.controls.city.value,
    //   countryCode: this.newAddressForm.controls.countryCode.value,
    //   latitude: this.newAddressForm.controls.latitude.value,
    //   longitude: this.newAddressForm.controls.longitude.value,
    //   street: this.newAddressForm.controls.street.value,
    //   Street2: this.newAddressForm.controls.street2.value,
    //   validatedBy: this.newAddressForm.controls.validatedBy.value,
    //   zipCode: this.newAddressForm.controls.zipCode.value,
    //   id: this.newAddressForm.controls.id.value,
    // } as Address
    this.ref.close();
  }
  map: Leaflet.Map;
  options: Leaflet.MapOptions = {
    layers: this.getLayers(),
    zoom: 12,
    center: new Leaflet.LatLng(55.676098, 12.568337),
  };
  useMap() {

  }

  getLayers(): Leaflet.Layer[] {
    return [
      new Leaflet.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors',
      } as Leaflet.TileLayerOptions),
    ] as Leaflet.Layer[];
  };
}
